"use client";

import { c as _c } from "react/compiler-runtime";
import { createContext, useContext, useMemo, type ReactNode } from "react";
import { useWebHaptics } from "web-haptics/react";
type Haptics = ReturnType<typeof useWebHaptics>;
const HapticsContext = createContext<Haptics | null>(null);
export function HapticsProvider(t0) {
  const $ = _c(7);
  const {
    children
  } = t0;
  const {
    trigger,
    cancel,
    isSupported
  } = useWebHaptics();
  let t1;
  if ($[0] !== cancel || $[1] !== isSupported || $[2] !== trigger) {
    t1 = {
      trigger,
      cancel,
      isSupported
    };
    $[0] = cancel;
    $[1] = isSupported;
    $[2] = trigger;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const value = t1;
  let t2;
  if ($[4] !== children || $[5] !== value) {
    t2 = <HapticsContext.Provider value={value}>{children}</HapticsContext.Provider>;
    $[4] = children;
    $[5] = value;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
}
export function useHaptics() {
  const haptics = useContext(HapticsContext);
  if (!haptics) {
    throw new Error("useHaptics must be used within HapticsProvider");
  }
  return haptics;
}